module.exports = __webpack_public_path__ + "static/media/decisionJam.6653adb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/decisionJam.png
// module id = 34
// module chunks = 0